import React, { useState } from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";

function FAQ() {
  const [close, setClose] = useState(false);

  const handleClick = () => {
    setClose(true);
  };

  return (
    <div class="main-container">
      <Navbar />

      <div class="col-12 contact-top">
        <div class="mt-5">
          <div class="text-center col-lg-5 col-12 m-auto">
            <h3>FAQ</h3>
            <p>
              Nous avons répondu à certaines de vos questions fréquemment posées
              ci-dessous :
            </p>
          </div>

          <div class="accordion-container col-md-6 col-12 m-auto" id="accord">
            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo"
              >
                Le forfait illimité est-il vraiment illimité ?
              </button>
              <div class="collapse" id="demo">
                <p>
                  Oui, le forfait illimité est VRAIMENT ILLIMITÉ, sans aucun
                  plafond de données.
                </p>
              </div>
            </div>
            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo1"
              >
                Combien de temps dure l'installation ?
              </button>
              <div class="collapse" id="demo1">
                <p>L'installation prend généralement 30 à 45 minutes.</p>
              </div>
            </div>
            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo2"
              >
                Comment puis-je effectuer le paiement ?
              </button>
              <div class="collapse" id="demo2">
                <p>
                  Les paiements peuvent être effectués via l'une de nos
                  plateformes de paiement ou directement sur notre compte
                  bancaire :
                </p>
                <p>Coming Soon</p>
                {/* <p>Zenith Bank PLC </p>
                <p>Numéro de compte: 6010177693 </p> */}
              </div>
            </div>

            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo3"
              >
                A combien s'élèvent les frais d'installation ?
              </button>
              <div class="collapse" id="demo3">
                <p>
                  L'installation est une redevance unique de <b>FCFA 55000 </b>
                  pour les plans résidentiels et commerciaux. Le coût
                  d'installation des plans dédiés varie.{" "}
                </p>
              </div>
            </div>

            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo6"
              >
                Que dois-je faire en cas d'Internet lent ?
              </button>
              <div class="collapse" id="demo6">
                <p>
                  La première étape consiste à vérifier que les câbles LAN et
                  POE sont correctement fixés et que le boîtier POE est bien
                  branché avec une lumière blanche fixe pour éviter les
                  fluctuations.
                </p>
              </div>
            </div>

            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo4"
              >
                Suis-je propriétaire des appareils ?
              </button>
              <div class="collapse" id="demo4">
                <p>
                  Les appareils appartiennent à la société (CIVWifi) et sont
                  fournis pour la durée de notre service avec vous.
                </p>
              </div>
            </div>

            <div class="mb-3">
              <button
                class="accordion"
                data-toggle="collapse"
                data-target="#demo5"
              >
                Comment puis-je contacter l'assistance
              </button>
              <div class="collapse" id="demo5">
                <p>Vous pouvez contacter le support sur internet@civwifi.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default FAQ;
